import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=ae729c2a&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=ae729c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae729c2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae729c2a')) {
      api.createRecord('ae729c2a', component.options)
    } else {
      api.reload('ae729c2a', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=ae729c2a&scoped=true&", function () {
      api.rerender('ae729c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8EuT8dgEfhFju/JS/comp/CookieBox.vue"
export default component.exports